import notification_simple_ogg from "../assets/notification_simple-01.ogg";
import notification_simple_mp3 from "../assets/notification_simple-01.mp3";

const oggSupport = (new Audio().canPlayType("audio/ogg"));
const notification_simple = new Audio(oggSupport ? notification_simple_ogg : notification_simple_mp3);

export const playNotification = () => {
  notification_simple.play();
}